// Project
import request from "../request";

export const generateRecentLoginsCsv = async (env) => {
	const response = await request({
		url: `${env}/marketing/generate-recent-logins`,
	});

	return response.data;
};
